module.exports = __webpack_public_path__ + "static/sc_8-8fadd01cd08805c29b1ba2231af6a594.jpg";